<template>
  <div class="product-tab" v-bind:class="{hover: isHover && !item.active, active: item.active}" @mouseover="mouseOver" @mouseout="mouseOver">
    <div class="text-container">
      <span>
        {{ item.name }}
      </span>
    </div>
  </div>
</template>
<script>
import { isMobileDevice } from '@/utils/device'

export default {
  name: 'ProductTab',
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      isHover: false
    }
  },
  methods: {
    mouseOver () {
      if (!isMobileDevice()) this.isHover = !this.isHover
    }
  }
}
</script>
<style scoped>
.centro-de-ayuda .product-tab {
  background: #FFFFFF;
  border: 1.59px solid #F2F2F2;
  box-shadow: 0px 2.89px 2.89px rgba(112, 112, 112, 0.25);
  border-radius: 16.4282px;
  padding-top: 17px;
  padding-bottom: 17px;
  max-width: 292px;
  width: 282px;
  margin: 15px;
  margin-top: 35px;
  font-size: 10px;
  cursor: pointer;
  display: flex;
}
.centro-de-ayuda .product-tab.active{
  border: 1.59px solid #0855C4;
  background: #0855C4;
  color: #fff;
  box-shadow: 0px 2.89px 2.89px rgba(112, 112, 112, 0.25);
  border-radius: 24px;
}
.centro-de-ayuda .product-tab.hover span{
  font-family: 'Omnes Regular';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #0855C4;
}
.centro-de-ayuda .product-tab.hover{
  padding-bottom: 17px;
  padding-top: 17px;
}
.centro-de-ayuda .product-tab .text-container{
  width: 100%;
  align-items: center;
  justify-items: center;
  padding-left: 13px;
  padding-right: 13px;
}
.centro-de-ayuda .product-tab span {
  font-family: 'Omnes Regular';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 12px;
  text-align: center;
  color: #454A6C;
}

.centro-de-ayuda .product-tab.active span {
  color: #fff;
}
@media only screen and (max-width: 768px) {
  .centro-de-ayuda .product-tab {
    max-width: 100%!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/help-center/ProductTab.vue